import styled from 'styled-components'

import { FlexCentered, ColumnFlex } from 'components/common/genericStyles'

export const Wrapper = styled.div`  
    left: 70%;
    bottom: 60%;
    width: 20px;
    height: 20px;
    padding: 2px 8px;
    position: absolute;
    background: #089864;
    border-radius: 50%;
    ${FlexCentered}
    ${ColumnFlex}
    ${props => props.css}
`
